.sharing {
  margin-top: -0.5rem;

  .btn {
    margin-top: 0.5rem;
    margin-right: 0.5rem;
  }
}
